export enum StockLevelStatus {
  OutOfStock = 'outOfStock',
  InStock = 'inStock',
}
